import { useQuery } from '@tanstack/react-query';
import { useInjection } from 'inversify-react';
import { type ISignatureService, SignatureService } from '../../services/signature';
import { useValidatedTenantId } from '../auth/use-validated-tenant-id';
import { signatureQueryKeys } from './query-keys';

/**
 * Hook per recuperare la firma dell'utente corrente.
 * Utilizza TanStack Query per gestione cache e stato.
 *
 * Niente placeholderData: senza di esso, isLoading è true sul primo render
 * e il consumer può mostrare uno spinner. Con placeholderData({hasSignature:false}),
 * isLoading è sempre false e il dialog di configurazione firma apparirebbe
 * brevemente anche quando la firma esiste (race condition su page reload).
 *
 * Chiave scoped per tenant (Fase 1, firma per sede): senza, uno switch sede
 * lascerebbe visibile in cache la firma della sede precedente finché
 * qualcos'altro non invalida la query.
 */
export function useMySignature() {
  const service = useInjection<ISignatureService>(SignatureService);
  const currentTenantId = useValidatedTenantId();

  return useQuery({
    queryKey: signatureQueryKeys.me(currentTenantId ?? ''),
    queryFn: () => service.getMySignature(),
    enabled: !!currentTenantId,
  });
}
